import { useLocation as useRealLocation } from "react-router-dom";
import { isLiveEnvironment } from "../common/testHelpers";
/* eslint-disable @typescript-eslint/no-explicit-any */
export var useLocation = isLiveEnvironment()
    ? useRealLocation
    : function () { return ({
        hash: "some_hash",
    }); };
/* eslint-enable @typescript-eslint/no-explicit-any */
